"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gtmEvent = gtmEvent;
exports.fsEvent = fsEvent;
exports.segmentIdentifyAnonymous = segmentIdentifyAnonymous;
exports.segmentTrack = segmentTrack;
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  Analytics Helpers
*/

/**
 * Log an event with GTM. Adds an event to the dataLayer that GTM knows how to log
 * to GA.
 * @param {String} eventName name of event
 * @param {Object} properties Object of associated data
 */
function gtmEvent(eventName, properties) {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(_objectSpread(_objectSpread({}, properties), {}, {
      event: eventName
    }));
  }
}
/**
 * Log an event with FullStory.
 * @param {String} eventName name of event
 * @param {Object} properties Object of associated data
 */


function fsEvent(eventName, properties) {
  if (typeof window !== 'undefined') {
    var _window = window,
        FS = _window.FS;

    if (FS && typeof FS.event === 'function') {
      FS.event(eventName, properties);
    }
  }
}

var segmentIsDefined = function segmentIsDefined() {
  return typeof window !== 'undefined' && window.analytics;
};
/**
 * Identify a Segment user. Uses an auto-generated anonymous ID.
 * https://segment.com/docs/connections/spec/identify/
 * @param {object} [traits]
 */


function segmentIdentifyAnonymous(traits) {
  if (segmentIsDefined()) {
    window.analytics.identify(traits);
  }
}
/**
 * Send an event to Segment
 * https://segment.com/docs/connections/spec/track/
 * @param {string} event
 * @param {object} [properties]
 */


function segmentTrack(event, properties) {
  if (segmentIsDefined()) {
    window.analytics.track(event, properties);
  }
}

var _default = {
  fsEvent: fsEvent,
  gtmEvent: gtmEvent,
  segmentIdentifyAnonymous: segmentIdentifyAnonymous,
  segmentTrack: segmentTrack
};
exports["default"] = _default;